import { render, staticRenderFns } from "./agentesDeComercio.vue?vue&type=template&id=86dfa09e"
import script from "./agentesDeComercio.vue?vue&type=script&lang=js"
export * from "./agentesDeComercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports